import './App.css';
import './components/countdown.js'
import Countdown from './components/countdown.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
//import ExampleCarouselImage from 'components/ExampleCarouselImage';
import Image from 'react-bootstrap/Image';

/*import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';*/

import mes1 from "./imagenes/mes1.png"
import mes2 from "./imagenes/mes2.png"
import mes3 from "./imagenes/mes3.png"
import mes4 from "./imagenes/mes4.png"
import mes5 from "./imagenes/mes5.png"
import mes6 from "./imagenes/mes6.png"
import mes7 from "./imagenes/mes7.png"
import mes8 from "./imagenes/mes8.png"
import mes9 from "./imagenes/mes9.png"
import mes10 from "./imagenes/mes10.png"
import mes11 from "./imagenes/mes11.png"

/*import nombre from "./imagenes/nombre.png"*/
import fecha from "./imagenes/fecha.png"



import asistencia from "./imagenes/asistencia.png"

import iglesia from "./imagenes/iglesia.png"
import banquete from "./imagenes/banquete.png"
import ubicacionsalon from "./imagenes/ubicacionsalon.png"
import ubicacioniglesia from "./imagenes/ubicacioniglesia.png"
import frase11 from "./imagenes/frase-1.png"
import fraseregalos from "./imagenes/fraseregalos.png"
import fraseregalos2 from "./imagenes/fraseregalos2.png"
import fraseregalostrans from "./imagenes/fraseregalostrans.png"
import nombre1 from "./imagenes/nombre-1.png"
import madrina from "./imagenes/madrina.png"
import padrino from "./imagenes/padrino.png"
import mama from "./imagenes/mama.png"
import papa from "./imagenes/papa.png"
import frasepadrinos from "./imagenes/frasepadrinos.png"
import frasepadres from "./imagenes/drasepadres.png"
import frasefinal from "./imagenes/frasefinal.png"
import linea from "./imagenes/lineadivision.png"
import imghotel1 from "./imagenes/hotel1.png"
import imghotel2 from "./imagenes/hotel2.png"




function Hospedaje() {
    return (
        <div className="Hospedaje">
                  <Container>
                        {/*<Row className='cancion-fondo'>
                        <iframe data-testid="embed-iframe"  src="https://open.spotify.com/embed/track/70ygVDJv1Wou8WGD34K5An?utm_source=generator" width="50%" height="152" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                        </Row>*/}
                    <Container>
                        <Row>

                        <Col className='col-titulo'>
                            <Image src={nombre1} width="80%"/>
                        </Col>
                        </Row>
                        </Container>

                        <Container className='cont-carusel'>
                        <Col xs={10} md={10} class="row align-items-center">
                            <Carousel>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="First slide" />*/}
                                <Image src={mes1} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Second slide" />*/}
                                <Image src={mes2} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Third slide" />*/}
                                <Image src={mes3} width="100%" />
                            </Carousel.Item>

                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="First slide" />*/}
                                <Image src={mes4} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Second slide" />*/}
                                <Image src={mes5} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Third slide" />*/}
                                <Image src={mes6} width="100%" />
                            </Carousel.Item>

                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="First slide" />*/}
                                <Image src={mes7} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Second slide" />*/}
                                <Image src={mes8} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Third slide" />*/}
                                <Image src={mes9} width="100%" />
                            </Carousel.Item>
                             <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Third slide" />*/}
                                <Image src={mes10} width="100%" />
                            </Carousel.Item>
                            <Carousel.Item interval={5000}>
                                {/*<ExampleCarouselImage text="Third slide" />*/}
                                <Image src={mes11} width="100%" />
                            </Carousel.Item>

                            </Carousel>
                        </Col>
                    </Container>
                </Container>
                    <Container className='cont-fecha'>
                        <Row>
                        <Col>
                            <Image src={fecha} width="100%"/>
                        </Col>
                        </Row>
                    </Container>
                    {/*<Container className='cont-fecha'>
                        <Row>
                        <Col xs={6} md={5}></Col>
                        <Col xs={6} md={5} class="row align-items-center">
                            <Image src={fecha} width="100%" />
                        </Col>
                        <Col xs={6} md={5}></Col>
                        </Row>
                    </Container>*/}

                    <Container className='cont-temp'>
                        <Col xs={9} md={8} class="row align-items-center">
                        <Countdown/>
                        </Col>
                    </Container>
                    <Container className='cont-leyenda'>
                        <Col>
                        <Image src={frase11} width="100%" className='img-desvanecido'/>
                    </Col>
                    </Container>

                    <Container className='cont-padres'>
                        <Row>
                        <Col>
                            <h2>Papás</h2>
                        </Col>
                        </Row>
                        <Row className='cont-cont-padres'>
                        
                        <Row className='cont-padres-img'>
                        <Col xs={6} md={6}>
                            <Image src={papa} width="100%"/>
                        </Col>
                        <Col xs={6} md={6}>
                            <Image src={mama} width="100%"/>
                        </Col>
                        </Row>
                
                        <Row>
                        <Col className='text-frases-padr'>
                            <Image src={frasepadres} width="100%"/>
                        </Col>
                        </Row>

                        </Row>
                    </Container>

                   <Container className='cont-padrinos'>

                                <Row>
                        <Col>
                            <h2>Padrinos </h2>
                        </Col>
                        </Row>
                        <Row className='cont-cont-padrinos'>

                        <Row  className='cont-padrinos-img'>
                        <Col>
                            <Image src={padrino} width="100%" />
                        </Col>
                        <Col>
                            <Image src={madrina} width="100%" />
                        </Col>
                        </Row>

                        <Row className='text-frases-padr'>
                        <Col>
                            <Image src={frasepadrinos} width="100%" />
                        </Col>
                        </Row>

                        </Row>

                    </Container>

                    <Container className='cont-leyenda-2'>
                        <Col>
                            <Image src={fraseregalostrans} width="100%" className='img-desvanecido'/>
                        </Col>
                    </Container>

                    {/*
                    <Col xs={4} md={3} class="row justify-content-center">
                            <Image src={lugar} width="100%" />
                            </Col>
                    */}

                    <Container className='cont-ubi-iglesia' >
                        <Row>
                        <Image src={linea} width="100%" />
                        </Row>
                        <div>
                        <h2 className='titulosup-ubicaciones'>Iglesia</h2>
                        </div>
                        <Row>
                        <Col>
                            <Image src={iglesia} width="100%" />
                        </Col>
                        <Col>
                            <Col className='img-desvanecido'><h3>Parroquia <br/>Cristo Rey de Reyes</h3></Col>
                            <Col className='img-desvanecido'><p className='text-info-iglesia'>Av. Barrios y Av. Indeco, 54090 Tlalnepantla, Méx.</p></Col>
                            <Col className='img-desvanecido'><p className='text-info-iglesia'>Horario de misa : 12:00.</p></Col>
                        </Col>
                        </Row>
                        <Row className='img-iglesia'>
                            <a href="https://maps.app.goo.gl/LWxXSsD54tdGokRV6" target="_blank"><Image src={ubicacioniglesia} width="100%" /></a> 
                        </Row>
                    </Container>

                    <Container>
                        <Row>
                        <Image src={linea} width="100%" />
                        </Row>
                    </Container>
                    
                    <Container className='cont-ubi-banquete'>
                        <Row>
                        <div>
                            <h2 className='titulosup-ubicaciones'>Salón</h2>
                        </div>
                        
                        <Col>
                            <Col className='img-desvanecido'><h3 className='text-lafinca'>La Finca</h3></Col>
                            <Col className='img-desvanecido'><p className='text-info-ubi'>Manantiales 12, 54576 Santa Ana Jilotzingo, Méx.</p></Col>
                            <Col className='img-desvanecido'><p className='text-info-ubi'>Horario de recepción : 14:30. </p></Col>
                            <Col className='img-desvanecido'><p className='text-info-ubi'>Horario de comida : 15:00. </p></Col>
                        </Col>
                        <Col className='img-banquete'>
                            <Image src={banquete} width="100%" />
                        </Col>
                        </Row>
                        <Row className='img-banquete'>
                            <a href="https://maps.app.goo.gl/v79Xt1mmm4VWR5cVA" target="_blank"><Image src={ubicacionsalon} width="100%" /></a>
                            </Row>
                        <Row>
                        <Image src={linea} width="100%" />
                        </Row>
                    </Container>

                    <Container className='cont-hospedaje'>
                        <Row className='cont-cont-hospedaje'>
                            <Col>
                                <h2 className='titulosup-hospedaje'>Sugerencias de hospedajes</h2>
                            </Col>
                                 <Row>
                                    <Row className='cont-hospedaje1'>
                                        <h4> Hotel & Villas Madeira</h4>
                                        <Col>
                                            <Image src={imghotel1} width="100%" />
                                        </Col>
                                        <Col>
                                            <div className='cont-agendar'>
                                                <div>
                                                    <a href="https://maps.app.goo.gl/QVo9yNPkfEAUBvVh7" target="_blank"><p>Ir a ubicación</p></a>
                                                </div>
                                                <div className='text-num-hospedaje'>
                                                    <p>Agendar hospedaje</p>
                                                </div>
                                                <div>
                                                     <a href="tel:+525558161500" target="_blank"><p> 5558161500</p></a>
                                                </div>
                                            </div>    
                                        </Col>
                                    </Row>
                                <Row className='cont-hospedaje2'>
                                    <h4>City Express Plus by Marriott<br/> Ciudad de México Mundo E</h4>
                                        <Col>
                                            <div className='cont-agendar'>
                                                <div>
                                                    <a href="https://maps.app.goo.gl/DsTH2aMvbz75Vg889" target="_blank"><p>Ir a ubicación</p></a>
                                                </div>
                                                 <div className='text-num-hospedaje'>
                                                    <p>Agendar hospedaje</p>
                                                </div>
                                                <div>
                                                    <a href="tel:+525521690880" target="_blank"><p>5521690880</p></a>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <Image src={imghotel2} width="100%" />
                                        </Col>
                                        
                                    </Row>
                                <Row className='cont-hospedaje3'>
                                    <h4>Fiesta Americana México Satélite</h4>
                                        <Col>
                                            <Image src={imghotel1} width="100%" />
                                        </Col>
                                        <Col>
                                            <div className='cont-agendar'>
                                                <div>
                                                    <a href="https://maps.app.goo.gl/4PCtxmVzA17uuqox8" target="_blank"><p>Ir a ubicación</p></a>
                                                </div>
                                                 <div className='text-num-hospedaje'>
                                                    <p>Agendar hospedaje</p>
                                                </div>
                                                <div>
                                                    <a href="tel:+524433108137" target="_blank"><p>4433108137</p></a>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                <Row className='cont-hospedaje4'>
                                    <h4>City Express by Marriott <br/> Ciudad de México Tlalnepantla</h4>
                                        <Col>
                                            <div className='cont-agendar'>
                                                <div>
                                                    <a href="https://maps.app.goo.gl/J9dWtvuWSPVeyKRh7" target="_blank"><p>Ir a ubicación</p></a>
                                                </div>
                                                 <div className='text-num-hospedaje'>
                                                    <p>Agendar hospedaje</p>
                                                </div>
                                                <div >
                                                    <a href="tel:+525576077000" target="_blank"><p>5576077000</p></a>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <Image src={imghotel2} width="100%" />
                                        </Col>
                                        
                                    </Row>
                            </Row>
                        </Row>
                        
                    </Container>


                    <Container className='cont-asist' >
                        <Col class="row justify-content-center">
                            <a href="https://wa.me/5213314247371?text=¡Hola!,%20Confirmamos%20nuestra%20asistencia." target="_blank"><Image src={asistencia} width="100%" /></a>
                        </Col>
                        <Col class="row justify-content-center">
                            {/*<p>Es un honor compartir contigo la felicidad de este esperado bautizo.<br/> ¡Ven a celebrar con nosotros!</p>*/}
                            <Image src={frasefinal} width="100%" className='img-desvanecido'/>
                        </Col>
                        
                    </Container>
        </div>

    );

}

export default Hospedaje;